// Helper function to get Berlin timezone offset
const getBerlinOffset = (date) => {
  const berlin = new Date(
    date.toLocaleString('en-US', { timeZone: 'Europe/Berlin' })
  );
  const utc = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }));
  return utc.getTime() - berlin.getTime();
};

export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

export const setCookie = (name, value, days) => {
  const targetDate = new Date();
  targetDate.setDate(targetDate.getDate() + (days + 1)); // +1 to ensure it lasts full days

  // Create date in Berlin timezone at 8 AM
  const berlinDate = new Date(targetDate.toLocaleDateString('en-CA')); // YYYY-MM-DD format
  berlinDate.setHours(8, 0, 0, 0);

  // Convert Berlin time to UTC
  const berlinOffset = getBerlinOffset(berlinDate);
  const utcExpires = new Date(berlinDate.getTime() - berlinOffset);

  document.cookie = `${name}=${value};expires=${utcExpires.toUTCString()};path=/`;
};
